"use client";

import { Switch } from "@/components/ui/switch";
import { useTranslations } from "next-intl";
import { useState } from "react";

const CustomerSwitch = () => {
  const t = useTranslations("common");

  const [isBusinessType, setIsBusinessType] = useState(true);

  return (
    <div className="s:flex-row flex flex-col items-center justify-center gap-2 pb-5">
      <label
        htmlFor="customer"
        className={`${isBusinessType ? "text-primary" : "text-ring"} text-lg font-medium transition-colors duration-300`}
      >
        {t("businessCustomer")}
      </label>
      <Switch
        className="cursor-pointer"
        id="customer"
        checked={isBusinessType}
        onCheckedChange={(checked) => setIsBusinessType(checked)}
      />
      <label
        htmlFor="customer"
        className={`${!isBusinessType ? "text-primary" : "text-ring"} text-lg font-medium transition-colors duration-300`}
      >
        {t("privateCustomer")}
      </label>
    </div>
  );
};

export default CustomerSwitch;
